import React from "react"
import FixedDateImg from "../../../../../assets/avia/search/fix-date.png"
import FlexDateImg from "../../../../../assets/avia/search/flex-date.png"
import { cn } from "../../../../../lib"
import { useTranslation } from "react-i18next"
import { t } from "i18next"
import { useDispatch } from "react-redux"
import { DATES_FIX_MODE, DATES_FLEX_MODE } from "../../utils/variables/search"
import { setAviaSearchParams } from "../../../../../app/reducers/book/aviaSearchSlice"
import { motion } from "framer-motion"

const DateModalTopHead = ({ mode, from, to, isDeparture }) => {
  const dispatch = useDispatch()

  const { t } = useTranslation()

  // handlers
  const handleModeChange = (newMode) => {
    dispatch(setAviaSearchParams({ key: "dates.mode", value: newMode }))

    if (newMode === DATES_FIX_MODE) {
      if (from && from.length > 1) {
        dispatch(setAviaSearchParams({ key: "dates.from", value: [from[0]] }))
      }

      if (to && to.length > 1) {
        dispatch(setAviaSearchParams({ key: "dates.to", value: [to[0]] }))
      }
    }
  }

  return (
    <div className="flex relative items-center gap-8 px-4 py-1 ">
      <div className="absolute bottom-0 left-4 right-4 border-b border-dashed border-light-gray/25"></div>

      <DateType mode={mode} type={DATES_FIX_MODE} t={t} onChange={handleModeChange} />
      {isDeparture && (
        <DateType mode={mode} type={DATES_FLEX_MODE} t={t} onChange={handleModeChange} />
      )}
      {/* <div className="ml-auto flex flex-col  items-start gap-1">
        <FlightType t={t} type="direct" />
        <FlightType t={t} />
      </div> */}
    </div>
  )
}

export default DateModalTopHead

const DateType = ({ type, t, mode, onChange }) => {
  const imgClass = "w-[18px] h-[18px]"
  const isActive = mode === type

  return (
    <div
      onClick={() => onChange(type)}
      className={cn(
        "relative py-1 px-1.5 rounded-sm cursor-pointer flex gap-1.5 items-center",
        "text-dark-gray"
      )}
    >
      {isActive && (
        <motion.div
          layoutId="date-type-bg"
          className="absolute inset-0 bg-bg-secondary rounded-sm"
          transition={{
            type: "spring",
            stiffness: 500,
            damping: 35,
          }}
        />
      )}

      {/* content */}
      <div className="relative z-10 flex gap-1.5 items-center">
        {type === DATES_FIX_MODE ? (
          <img className={imgClass} src={FixedDateImg} alt="fixed date icon" />
        ) : (
          <img className={imgClass} src={FlexDateImg} alt="flexible date icon" />
        )}

        <span className="font-medium text-[11px] whitespace-nowrap">
          {type !== DATES_FIX_MODE ? t("admin.flexible_dates") : t("admin.fixed_dates")}
        </span>
      </div>
    </div>
  )
}

const FlightType = ({ type }) => {
  const bgColor = type === "direct" ? "bg-blue-400" : "bg-red-400"
  return (
    <div className="flex gap-2 text-dark-gray items-center text-[11px]">
      <div className={cn("w-[5px] h-[5px] rounded-full", bgColor)}></div>-
      <span>{type === "direct" ? t("admin.direct_flight") : t("admin.connecting_flight")}</span>
    </div>
  )
}
